{
    "walk-one-hour": "Seguir",
    "your-family": "Os seus",
    "you": "você",
    "wife": "esposa",
    "son": "filho",
    "daughter": "filha",
    "bag-is-empty": "Bolsa"
}
